export enum ListInterpretationMode {
    List = 1,
    Hidden = 2
}